import { apiPublic } from '../../api/client';
import type { SalaahTimesTodayResponse } from './types';

export async function getTodaySalaahTimes(): Promise<SalaahTimesTodayResponse> {
  return apiPublic.get<SalaahTimesTodayResponse>('/api/salaah-times/today');
}

export async function getSalaahTimesForDate(date: string): Promise<SalaahTimesTodayResponse> {
  return apiPublic.get<SalaahTimesTodayResponse>(`/api/salaah-times/date/${date}`);
}
